export default "__VITE_ASSET__B3CefQA7__"